import React, { FC, useEffect } from 'react';
import { Switch, Route, useHistory } from 'react-router-dom';
import AuthWrapper from '../AuthWrapper/AuthWrapper';
import { PackageSummary } from '../Enrollment';
import { HomePage } from '../Home/HomePage';
import { NotificationBlock } from '../NotificationsBlock';
import { SideNav } from '../SideNav';
import { Landing } from '../Enrollment/Wizard';
import { TopBar } from '../TopBar/TopBar';
import { Register } from '../Register';
import './App.scss';
import { userService } from '../../utils/UserService';
import { Callback } from '../Callback';
import Logout from '../Logout/Logout';
import { useTracking } from '../../hooks/googleAnalytics/useTracking';
import { TermsAndConditionsModal } from '../Modals/TermsAndConditionsModal';
import { ApplicationRoutes } from '../../routes/ApplicationRoutes';
import { Col, Container, Row } from 'react-bootstrap';
import { PublicEnrollmentLanding } from '../PublicEnrollment/PublicEnrollmentLanding';

const App = () => {
	useEffect(() => {
		// When the app loads, we need to resolve the current person, from
		// either the query string or otherwise.
		// The placement of this call is important, as if it is placed any later
		// in the call chain, it will likely fire too late to be used by sub-components.
		userService._initializeFromQueryString();
	}, []);

	if (window.location.hostname === 'enrollment.5g.wolftracs.com') {
		useTracking();
	}
 
	return (
		<div className="wrapper">
			<TermsAndConditionsModal />
			<NotificationBlock />
			<TopBar />
			<SideNav />
			<Container fluid className="main-view">
				<Row className="skelly-shell">
					<Col className="mt-2">
						<Switch>
							<AuthWrapper path={ApplicationRoutes.applicationRoot} exact component={HomePage} />

							<Route path={ApplicationRoutes.callback} component={Callback} />
							<Route path={ApplicationRoutes.logout} component={Logout} />
							<Route path={ApplicationRoutes.register} component={Register} />
							<Route path="/enroll/:publicId" component={PublicEnrollmentLanding} />
							<AuthWrapper path="/packages/:packageid" component={Landing} />
							<AuthWrapper path="/approved-summary/:packageid" exact component={PackageSummary} />
						</Switch>
					</Col>
				</Row>

			</Container>
			<div id="divModel" className="tc"><img src="/media/wolftracs_logo.png" width="150" alt="WolfTracs logo" /><br />WolfTracs&#8480; 5G | Enrollment &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
		</div>
	);
};

export default App;
